import { render } from "./chatRightList.vue?vue&type=template&id=4b4952b8"
import script from "./chatRightList.vue?vue&type=script&lang=js"
export * from "./chatRightList.vue?vue&type=script&lang=js"

import "./chatRightList.vue?vue&type=style&index=0&id=4b4952b8&lang=scss"

import exportComponent from "D:\\Git\\思途茶业\\思途茶业pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__